// extracted by mini-css-extract-plugin
export default {"wrapper":"CopyableBlockquote_wrapper__9xJDG","copyBtn":"CopyableBlockquote_copyBtn__p-XxM","blockquote":"CopyableBlockquote_blockquote__RHGdN"};